import { render, staticRenderFns } from "./admin-ticket-list.vue?vue&type=template&id=31806b8c"
import script from "./admin-ticket-list.vue?vue&type=script&lang=js"
export * from "./admin-ticket-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31806b8c')) {
      api.createRecord('31806b8c', component.options)
    } else {
      api.reload('31806b8c', component.options)
    }
    module.hot.accept("./admin-ticket-list.vue?vue&type=template&id=31806b8c", function () {
      api.rerender('31806b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ticket/admin-ticket-list.vue"
export default component.exports